/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Drew Burnett, Brian Bal
 */

// Get the game time

const getGameTime = (game) => {
    // Get the game time
    let gameTime = 0
    if (game) {
        let videoElement = document.querySelector(
            // eslint-disable-next-line quotes
            '.VideoPlayer video.main-video[data-active="true"]'
        )
        if (videoElement) {
            gameTime += videoElement.currentTime
        }
        gameTime = Math.round(gameTime)
    }
    return gameTime
}

export { getGameTime }
